import { gcmEncrypt } from '../crypto/msgCrypto';
// import Config from '@src/config';
import moment from 'moment';

import Config from '../config';
import {logMessage} from '../components/utils.js';

let url = Config.feedPortalUrl;

export enum StockFieldConstant {
    INXCODE = 0,
    STKCODE = 1,
    STKNAME = 2,
    CLOSE = 3,
    OPEN = 4,
    HIGH = 5,
    LOW = 6,
    LAST = 7,
    LVOL = 8,
    LVAL = 9,
    VOL = 10,
    VAL = 11,
    TRANS = 12,
    CHANGE = 13,
    CHANGE_PER = 14,
    VWAP = 15,
    BUY = 16,
    SELL = 17,
    BUYQ = 18,
    SELLQ = 19,
    BUYO = 20,
    SELLO = 21,
    REF = 22,
    REF1 = 23,
    LIMIT_U = 24,
    LIMIT_L = 25,
    BUYRATE_PER = 26,
    MARKPRICE = 27,
    GAP = 28,
    MID = 29,
    SPREAD = 30,
    PRIORMTH_CLS = 31,
    PRIORYR_CLS = 32,
    CHANGESINCE_OPN = 33,
    MTDCHANGE = 34,
    MTDCHANGE_PER = 35,
    SWING = 36,
    SWING_PER = 37,
    YR_HIGH = 38,
    YR_LOW = 39,
    YR_FRACTION = 40,
    YTD_CHANGE = 41,
    YTD_CHANGE_PER = 42,
    AVGPRICE = 43,
    AVRVOLUME = 44,
    TOPEN = 45,
    TOPENVOL = 46,
    UNDERLYINGPRC = 47,
    SHAREISSUED = 48,
    SHAREPRICE = 49,
    PARVALUE = 50,
    PAIDUP_CAP = 51,
    MKT_CAP = 52,
    PE = 53,
    EXCE_PRC = 54,
    INDICES = 55,
    SECTOR = 56,
    GROUP = 57,
    TYPE = 58,
    MARKET = 59,
    INDICATOR = 60,
    STATUS = 61,
    DELIVERY_BASIC = 62,
    LOTSIZE_MIN = 63,
    LOTSIZE_MAX = 64,
    STKNAME_LONG = 65,
    STKNAME_CHN = 66,
    EXCHANGE = 67,
    CURRENCY = 68,
    ISIN = 69,
    ENTITLEMENT = 70,
    REVENUE = 71,
    COUNTRY = 72,
    SUS_REASON = 73,
    DATE_MATURITY = 74,
    DATE = 75,
    DATE_SETTLE = 76,
    OFFERPRICE = 77,
    OFFERVOL = 78,
    BIVOL = 79,
    NETPROFIT = 80,
    M_INXCODE = 81,
    NEWS_TITLE = 82,
    LACP = 83,
    LTRANS_TYPE = 84,
    LTRANS_TIME = 85,
    LTRANS_NO = 86,
    TICK_DIRECTION = 87,
    OPEN_VOL = 88,
    OPEN_VAL = 89,
    OPEN_TRADES = 90,
    OMTM = 91,
    DBT_LTRANS_NO = 92,
    DBT_LTRANS_TIME = 93,
    DBT_LTRANS_TYPE = 94,
    DBT_LAST = 95,
    DBT_CHANGE = 96,
    DBT_LVOL = 97,
    DBT_LVAL = 98,
    DBT_VOL = 99,
    DBT_VAL = 100,
    DBT_TRANS = 101,
    DBT_VWAP = 102,
    DBT_TTL_SHARE = 103,
    DBT_HIGH = 104,
    DBT_LOW = 105,
    DBT_CLOSE = 106,
    DBT_REF = 107,
    OL_BUY = 108,
    OL_BUYQ = 109,
    OL_BUYO = 110,
    OL_SELL = 111,
    OL_SELLQ = 112,
    OL_SELLO = 113,
    OL_LTRANS_NO = 114,
    OL_LTRANS_TIME = 115,
    OL_LTRANS_TYPE = 116,
    OL_LAST = 117,
    OL_CHANGE = 118,
    OL_CHANGE_PER = 119,
    OL_LVAL = 120,
    OL_LVOL = 121,
    OL_VOL = 122,
    OL_VAL = 123,
    OL_TRANS = 124,
    OL_VWAP = 125,
    OL_BUYRATE_PER = 126,
    OL_HIGH = 127,
    OL_LOW = 128,
    OL_TOPEN = 129,
    OL_TOPENVOL = 130,
    OL_OPEN = 131,
    OL_OPEN_VOL = 132,
    OL_OPEN_VAL = 133,
    OL_OPEN_TRADES = 134,
    OL_CLOSE = 135,
    OL_LACP = 136,
    OL_REF = 137,
    OL_REF1 = 138,
    OL_YR_HIGH = 139,
    OL_YR_LOW = 140,
    OL_LIMIT_U = 141,
    OL_LIMIT_L = 142,
    OL_LOTSIZE_MIN = 143,
    OL_LOTSIZE_MAX = 144,
    EPS = 145,
    TCLOSE = 146,
    TCLOSE_VOL = 147,
    OL_TCLOSE = 148,
    OL_TCLOSE_VOL = 149,
    DELAY = 150,
    PRC_RANGE = 151,
    PRC_RANGE_PER = 152,
    SHARES_TO_PER = 155,
    VWAPLIST = 156,
    PDT_VOL = 157,
    PDT_VAL = 158,
    RSS_VOL = 159,
    RSS_VAL = 160,
    IDSS_VOL = 161,
    IDSS_VAL = 162,
    PSS_VOL = 163,
    PSS_VAL = 164,
    DIV_YIELD = 165,
    EX_RATIO = 166,
    W_TYPE = 167,
    GEARING = 168,
    PREMIUM = 169
}

export function encodeListToString(...list: number[]) {
    let iGroup = 0;
    const iColList = Array(24).fill(0);

    for (const colId of list) {
        // Adding value to group if not existing before
        const groupPOS = Math.floor((colId - 1) / 8);
        const groupVal = Math.pow(2, groupPOS);
        if ((iGroup & groupVal) !== groupVal) {
            iGroup += groupVal;
        }

        // Adding value to colList if not existing before
        const colPOS = (colId - 1) % 8;
        const colVal = Math.pow(2, colPOS);
        if ((iColList[groupPOS] & colVal) !== colVal) {
            iColList[groupPOS] += colVal;
        }
    }

    // Formatting the group value as a hexadecimal string of length 6
    let result = ('000000' + iGroup.toString(16)).slice(-6);

    for (const colVal of iColList) {
        if (colVal > 0) {
            result += String.fromCharCode(colVal);
        }
    }

    return result;
}


export async function getStock(
   stock_idxs:any,
   userId:string,
   exchangeCode:string
){
 // userId = 'azimo522'
  //userId = "azimo522"
    //const userId = 'fntuser02';
    const cryptoKey = moment().format('YYYYMMDD').toString('base64');

    let publicKey = gcmEncrypt(userId, cryptoKey);

    let arrStr = arrayToStringWithTrailingComma(stock_idxs);

    // Define request payload (req)
    const req = {
      searchkey: arrStr,
      "size": 0, 
      colsfield: encodeColsFieldFromArray2String([
        3,7, 22, 
        63, 83,
      ]),
      exchange: exchangeCode
    };

    // Fetch options
    const optInfo = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': publicKey, // Insert generated publicKey
      },
      body: JSON.stringify(req) // Send request payload in the body
    };

    try {
        // Fetch data using POST request
        const response = await fetch(url+'/stock/search', optInfo);
        const result = await response.json();

        logMessage("stock/search result",result)

        if (result.status === 1) {
          // Successfully received the stock data
          logMessage('Stock Data:', result.list);

          return result.list;

        } else {
          console.error('Failed to fetch stock data:', result);
        }
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }

      return [];
}

const  arrayToStringWithTrailingComma = (array:any) => {
    let arrayLength = array.length;
    let strArr = array.join(',');

    if (arrayLength ==  1) {
        strArr += ',';
    }

    return strArr;
}



const encodeColsFieldFromArray2String = (_colsFieldArray) => {
	// first 2 bytes is reserve for group [left to right ==> 1 to 16]
	var iGroup = 0;
	var iColList = new Array(24).fill(0);
	_colsFieldArray.forEach(ColId => {
		// adding value to group if no existing before
		var groupPOS = parseInt((ColId - 1) / 8, 10);
		var groupVal = Math.pow(2, groupPOS);
		if ((iGroup & groupVal) !== groupVal)
			iGroup += groupVal;
		// adding value to collist if no existing before
		var colPOS = (ColId - 1) % 8;
		var colVal = Math.pow(2, colPOS);
		if ((iColList[groupPOS] & colVal) !== colVal) {
			iColList[groupPOS] += colVal;
		}
	});
	// convert value t0 hex string and arrange in format <group><group><collist ...>
	var result = ('000000' + iGroup ?.toString(16)).slice(-6);
	iColList.forEach(ColVal => {
		if (ColVal > 0) {
			result += '\\u{' + ColVal.toString(16) + '}';  // Use hex Unicode format for safety
		}
	});
	return result;
};

